import PAGE_NAME from '@web/consts/PAGE_NAME'
import { SearchTab } from '@web/store/types/modules/search'

/**
 * Единая точка перехода на страницу результатов поиска.
 *
 * `tab` опционален и по умолчанию НЕ передаётся: новый запрос сбрасывает
 * активный таб на «Все» (согласовано с продуктом 2026-07-09). Это
 * единственное место, где переключается данное поведение — если продукт
 * решит сохранять выбранный таб, достаточно передать сюда текущий tab.
 *
 * ⚠️ ВНИМАНИЕ при смене этого решения: Search.vue отличает новый сабмит от
 * переключения таба по ОТСУТСТВИЮ `tab` в query. Если начать передавать `tab`
 * отсюда, повторный сабмит того же запроса перестанет логироваться —
 * молча, без ошибки. А логирование 100% запросов — цель всей фичи.
 * Меняя это, поправь и признак в Search.vue (router.afterEach).
 */
export function buildSearchLocation (query: string, tab?: SearchTab): { name: string; query: Record<string, string> } {
  return {
    name: PAGE_NAME.SEARCH,
    query: { q: query, ...(tab ? { tab } : {}) }
  }
}
